import { render, staticRenderFns } from "./advertisementInfo.vue?vue&type=template&id=c2ef6e2e&scoped=true"
import script from "./advertisementInfo.vue?vue&type=script&lang=js"
export * from "./advertisementInfo.vue?vue&type=script&lang=js"
import style0 from "./advertisementInfo.vue?vue&type=style&index=0&id=c2ef6e2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ef6e2e",
  null
  
)

export default component.exports